import { styled } from '@mui/material/styles';
import { generateScoreSvg } from 'kosmos/images';
import { useTranslation } from 'react-i18next';

const PREFIX = 'SustainabilityScoreCircle';

const classes = {
  root: `${PREFIX}-root`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    // flexGrow: 1,
    // backgroundColor: 'lightblue'
    backgroundColor: 'white',
    padding: 0,
    borderRadius: 5,
    textAlign: 'center',
    width: '100%',
    color: 'white',
  },
  '& .small': {
    position: 'relative',
    width: 200,
    height: 200,
    margin: 'auto',
    '& .text': {
      lineHeight: 1,
      position: 'absolute',
      color: 'black',
      fontSize: 12,
      left: '50%',
      top: '50%',
      marginTop: -25,
      marginLeft: -25,
      width: 50,
      height: 50,
      paddingTop: 10,
      '& .prop': {},
      '& .score': {
        fontSize: 20,
        fontWeight: 'bold',
      },
    },
  },

  '& .normal': {
    position: 'relative',
    width: 300,
    height: 300,
    margin: 'auto',

    '& .text': {
      lineHeight: 1,
      position: 'absolute',
      color: 'black',
      fontSize: 14,
      left: '50%',
      top: '50%',
      marginTop: -40,
      marginLeft: -40,
      width: 80,
      height: 80,
      paddingTop: 15,
      '& .prop': {},
      '& .score': {
        fontSize: 35,
        fontWeight: 'bold',
      },
    },
  },

  '& .tiny': {
    position: 'relative',
    width: 150,
    height: 150,
    margin: 'auto',

    '& .text': {
      lineHeight: 1,
      position: 'absolute',
      color: 'black',
      fontSize: 10,
      left: '50%',
      top: '50%',
      marginTop: -15,
      marginLeft: -15,
      width: 30,
      height: 30,
      paddingTop: 5,
      '& .prop': {},
      '& .score': {
        fontSize: 15,
        fontWeight: 'bold',
      },
    },
  },
}));

interface Props {
  width?: number;
  height?: number;
  score: number;
  size?: 'tiny' | 'small' | 'normal';
  prop?: string;
}

export default function SustainabilityScoreCircle(props: Props): JSX.Element {
  const { score, size = 'normal', prop } = props;

  const { t } = useTranslation('default');

  return (
    <Root className={classes.root}>
      <div className={size}>
        <img src={generateScoreSvg(score)?.default} />
        <div className="text">
          <div className="prop">{prop || t('total-score')}</div>
          <div className="score">{score}</div>
        </div>
      </div>
    </Root>
  );
}
